var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M15.9 4.04a.7.7 0 00-.99 0l-4.7 4.72-4.72-4.71a.7.7 0 00-.98.98l4.7 4.71-4.7 4.71a.7.7 0 00.98.99l4.71-4.71 4.71 4.7a.7.7 0 00.99 0 .7.7 0 000-.98l-4.71-4.7 4.7-4.72a.7.7 0 000-.99z"}})}
var staticRenderFns = []

export { render, staticRenderFns }